
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import styles from "pages/events/[eid]/Fifo.module.scss";
import { useEffect, useState } from "react";
import { Axios } from "api";
import classNames from "classnames";
import Link from "next/link";
import utilStyles from "styles/utils.module.scss";
import { pouchRoute, storeRoute } from "common/const";
import useTimer from "hooks/useTimer";
import DownloadIcon from "images/icons/download.svg";
import { useRouter } from "next/router";
import { customAlert } from "common/utils";
import { handleCouponDownload } from "components/modal/MainCouponModal";
import KakaoLoader from "components/KakaoLoader";
import CopyIcon from "images/icons/copy.svg";
import Clipboard from "react-clipboard.js";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/nextjs";
import useBulkNotiSubscription from "hooks/useBulkNotiSubscription";
import useTranslation from "next-translate/useTranslation";
const TYPE_100_DAY = '100_percent_day';
const TYPE_ALL_DEPLETED = 'all_depleted';
const TYPE_NORMAL = 'normal';
const CouponCard = ({ coupon, targetHour, blackButton }) => {
    const { timeString, seconds } = useTimer(coupon ? coupon.opens_at : 0);
    const { t } = useTranslation('components-modal-MainCouponModal');
    const shouldShowTimer = !!(seconds > 0 && !!coupon && !!coupon.opens_at);
    const router = useRouter();
    const [isLoading, setIsLoading] = useState(false);
    const onCouponDownloadSuccess = (couponIds) => {
        customAlert(`쿠폰을 다운로드 했어요. ${targetHour}시에 만나요!`, '확인', () => { });
        typeof mixpanel !== 'undefined' && mixpanel.track('FifoEventCouponDownloadSuccess', {
            couponMoldKey: coupon.mold_key
        });
    };
    const downloadDisabled = !coupon || (coupon.is_over_people_count);
    return (<div className={styles.coupon} onClick={() => {
            if (!coupon)
                return;
            if (downloadDisabled)
                return;
            handleCouponDownload(router, coupon, false, isLoading, setIsLoading, onCouponDownloadSuccess, t);
        }}>
            {shouldShowTimer &&
            <div className={styles.couponTimer}>
                    {timeString} 후 발급 가능
                </div>}
            {!shouldShowTimer &&
            <div className={classNames(styles.downloadButtonContainer, blackButton ? styles.downloadButtonContainerBlack : undefined)}>
                    <div className={styles.downloadButton}>
                        <div className={classNames(styles.downloadIconWrapper)}>
                            <DownloadIcon viewBox="0 0 19 18" width={'60%'} height={'60%'}/>
                        </div>
                    </div>
                </div>}
            {!!coupon && !!coupon.is_over_people_count &&
            <div className={styles.couponOverlay}>
                    <div className={styles.couponOverlayText}>
                        소진된 쿠폰이에요<br />내일 {targetHour}시에 다시 만나요!
                    </div>
                </div>}
        </div>);
};
const formatDate = (date) => {
    return `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}`;
};
const NormalDetail = ({ couponMolds, now }) => {
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12);
    const lastDate = new Date(2024, 0, 31, 12);
    return (<div className={styles.normalContainer}>
            <img src={"https://d1cnx04b8cgzcv.cloudfront.net/fifo/event_detail_2_3.png"} className={styles.secondDetailImage}/>
            <div className={classNames(styles.couponContainer, styles.normal100Coupon)}>
                <CouponCard blackButton targetHour={11} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(lastDate)}_${11}`))[0]}/>
            </div>
            <div className={classNames(styles.couponContainer, styles.normal50Coupon)}>
                <CouponCard targetHour={11} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(todayDate)}_${11}`))[0]}/>
            </div>
            <div className={classNames(styles.couponContainer, styles.normal30Coupon)}>
                <CouponCard targetHour={16} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(todayDate)}_${16}`))[0]}/>
            </div>
            <div className={classNames(styles.couponContainer, styles.normal20Coupon)}>
                <CouponCard targetHour={20} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(todayDate)}_${20}`))[0]}/>
            </div>
            <div className={classNames(styles.longButtonContainer, styles.normalStoreButton)} onClick={() => {
            typeof mixpanel !== 'undefined' && mixpanel.track('FifoEventStoreButtonClick');
        }}>
                <Link href={storeRoute}>
                    <a className={classNames(utilStyles.block, utilStyles.fullWidth, utilStyles.fullHeight)}/>
                </Link>
            </div>
            <div className={classNames(styles.longButtonContainer, styles.normalPouchButton)} onClick={() => {
            typeof mixpanel !== 'undefined' && mixpanel.track('FifoEventPouchButtonClick');
        }}>
                <Link href={pouchRoute}>
                    <a className={classNames(utilStyles.block, utilStyles.fullWidth, utilStyles.fullHeight)}/>
                </Link>
            </div>
        </div>);
};
const DepletedDetail = ({ couponMolds, now }) => {
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12);
    const lastDate = new Date(2024, 0, 31, 12);
    return (<div className={styles.normalContainer}>
            <img src={"https://d1cnx04b8cgzcv.cloudfront.net/fifo/event_detail_2_1.png"} className={styles.secondDetailImage}/>
            <div className={classNames(styles.couponContainer, styles.depletedCoupon100)}>
                <CouponCard blackButton targetHour={11} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(lastDate)}_${11}`))[0]}/>
            </div>
            <div className={classNames(styles.couponContainer, styles.depletedCoupon50)}>
                <CouponCard targetHour={11} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(todayDate)}_${11}`))[0]}/>
            </div>
            <div className={classNames(styles.couponContainer, styles.depletedCoupon30)}>
                <CouponCard targetHour={16} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(todayDate)}_${16}`))[0]}/>
            </div>
            <div className={classNames(styles.couponContainer, styles.depletedCoupon20)}>
                <CouponCard targetHour={20} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(todayDate)}_${20}`))[0]}/>
            </div>
        </div>);
};
const HundredDayDetail = ({ couponMolds, now }) => {
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12);
    const lastDate = new Date(2024, 0, 31, 12);
    return (<div className={styles.normalContainer}>
            <img src={"https://d1cnx04b8cgzcv.cloudfront.net/fifo/event_detail_2_2.png"} className={styles.secondDetailImage}/>
            <div className={classNames(styles.couponContainer, styles.hundredCoupon1)}>
                <CouponCard targetHour={11} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(lastDate)}_${11}`))[0]}/>
            </div>
            <div className={classNames(styles.couponContainer, styles.hundredCoupon2)}>
                <CouponCard targetHour={16} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(lastDate)}_${16}`))[0]}/>
            </div>
            <div className={classNames(styles.couponContainer, styles.hundredCoupon3)}>
                <CouponCard targetHour={20} coupon={couponMolds.filter(mold => mold.mold_key.startsWith(`${formatDate(lastDate)}_${20}`))[0]}/>
            </div>
            <div className={classNames(styles.longButtonContainer, styles.hundredStoreButton)} onClick={() => {
            typeof mixpanel !== 'undefined' && mixpanel.track('FifoEventStoreButtonClick');
        }}>
                <Link href={storeRoute}>
                    <a className={classNames(utilStyles.block, utilStyles.fullWidth, utilStyles.fullHeight)}/>
                </Link>
            </div>
            <div className={classNames(styles.longButtonContainer, styles.hundredPouchButton)} onClick={() => {
            typeof mixpanel !== 'undefined' && mixpanel.track('FifoEventPouchButtonClick');
        }}>
                <Link href={pouchRoute}>
                    <a className={classNames(utilStyles.block, utilStyles.fullWidth, utilStyles.fullHeight)}/>
                </Link>
            </div>
        </div>);
};
const BottomImage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const topicKeys = [
        '1st_anniv_fcfs_11',
        '1st_anniv_fcfs_16',
        '1st_anniv_fcfs_20',
    ];
    const { toggleSubscription } = useBulkNotiSubscription(topicKeys, '1주년 선착순 이벤트');
    const onSubscriptionClick = () => {
        if (isLoading) {
            toast.info('설정 중입니다. 잠시만 기다려주세요');
            return;
        }
        toggleSubscription();
    };
    const onKakaoShareClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('FifoEventKakaoShare');
        try {
            Kakao.Share.sendDefault({
                objectType: 'feed',
                content: {
                    title: '2주 내내 하루 세번 찾아오는 선착순 쿠폰💌',
                    description: '오전 11시, 낮 4시, 저녁 8시 최대 100% 쿠폰 받아가세요',
                    imageUrl: 'https://d1cnx04b8cgzcv.cloudfront.net/fifo/event_thumbnail.jpg',
                    link: {
                        // [내 애플리케이션] > [플랫폼] 에서 등록한 사이트 도메인과 일치해야 함
                        mobileWebUrl: 'https://www.hemekolab.com/events/1783',
                        webUrl: 'https://www.hemekolab.com/events/1783'
                    }
                },
                buttons: [
                    {
                        title: '선착순 도전하러 가기',
                        link: {
                            mobileWebUrl: 'https://www.hemekolab.com/events/1783',
                            webUrl: 'https://www.hemekolab.com/events/1783'
                        }
                    },
                ]
            });
        }
        catch (e) {
            Sentry.captureException(e);
        }
    };
    const onCopyLinkClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('FifoEventCopyLink');
        toast.info('링크가 복사되었어요');
    };
    return (<div className={styles.bottomContainer}>
            <img src={"https://d1cnx04b8cgzcv.cloudfront.net/fifo/event_detail_3.png"} className={styles.bottomDetailImage}/>
            <div className={styles.bottomSubscriptionButton} onClick={onSubscriptionClick}/>
            <div className={styles.kakaoShareButton} onClick={onKakaoShareClick}/>
            <div className={styles.copyLinkButton}>
                <Clipboard option-text={() => {
            if (typeof window === 'undefined')
                return 'https://www.hemekolab.com/events/1783';
            return window.location.href;
        }} onSuccess={onCopyLinkClick}/>
            </div>
        </div>);
};
const Fifo = ({ event }) => {
    const [couponMolds, setCouponMolds] = useState([]);
    const fetchCouponInfo = async () => {
        const res = await Axios.get(`v1/events/${event.id}/coupons/`);
        if (res.status < 400) {
            setCouponMolds(res.data.simple_coupon_list);
        }
    };
    const now = new Date();
    const currentDateString = formatDate(now);
    const todayCoupons = couponMolds.filter(coupon => coupon.mold_key.startsWith(currentDateString));
    const detailImageType = currentDateString === '20240131' ? TYPE_100_DAY : (todayCoupons && todayCoupons.length > 0 && todayCoupons.every(coupon => coupon.is_over_people_count) ? TYPE_ALL_DEPLETED : TYPE_NORMAL);
    useEffect(() => {
        fetchCouponInfo();
    }, []);
    return (<div>
            <KakaoLoader />
            {detailImageType === TYPE_100_DAY &&
            <HundredDayDetail couponMolds={couponMolds} currentDateString={currentDateString} now={now}/>}
            {detailImageType === TYPE_ALL_DEPLETED &&
            <DepletedDetail couponMolds={couponMolds} now={now}/>}
            {detailImageType === TYPE_NORMAL &&
            <NormalDetail couponMolds={couponMolds} now={now}/>}
            <BottomImage />
        </div>);
};
export default Fifo;

    async function __Next_Translate__getServerSideProps__1964211f16d__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/events/[eid]/Fifo',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1964211f16d__ as getServerSideProps }
  